import React, { useContext } from 'react'

// Node Modules
import { 
  useLocation
} from 'react-router-dom'
import axios from 'axios'
import { changeLanguage } from 'i18n'
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4'

// Components
import NotFound from 'components/NotFound'

// Context
import { InfoContext } from 'context/info-context'

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const NotFoundPage = () => {
  const location = useLocation()
  const info = useContext(InfoContext)
  const locale = useQuery().get('locale')

  const lang = locale || (info && info.languageBrowser) || 'en'

  axios.defaults.headers.common['Accept-Language'] = lang

  React.useEffect(() => {
    changeLanguage(lang)    
  }, [lang])
  
  React.useEffect(() => {
    const url = `${location.pathname}${location.search}`

    ReactGA.pageview(url)
    ReactGA4.send(url)
  }, [location])

  return <NotFound language={lang} />
}

export default NotFoundPage